import { fetchWrapper } from '@/_helpers';
import { realEstateListingsApi } from './listings';

function formatPriceChip(price) {
    if (price == null) return '-';
    if (price >= 1000000) return `$${(price / 1000000).toFixed(1)}M`;
    return `$${Math.round(price / 1000)}K`;
}

export const realEstateMapIntentApi = {
    parseMapIntent: (query) => {
        return fetchWrapper.post('real-estate/public/map-intent', { query });
    },
    fetchListingsWithFilters: (filters = {}) => {
        return realEstateListingsApi.getPublicListings({ ...filters, limit: filters.limit || 100 });
    },
    buildFilterChips: (filters) => {
        const chips = [];
        if (filters.propertyType) chips.push({ key: 'propertyType', label: filters.propertyType });
        if (filters.maxPrice != null)
            chips.push({ key: 'maxPrice', label: `Under ${formatPriceChip(filters.maxPrice)}` });
        if (filters.minPrice != null)
            chips.push({ key: 'minPrice', label: `Over ${formatPriceChip(filters.minPrice)}` });
        if (filters.opportunityZone) chips.push({ key: 'opportunityZone', label: 'OZ' });
        if (filters.zoning) chips.push({ key: 'zoning', label: `Zoned ${filters.zoning}` });
        if (filters.pipelineStage) chips.push({ key: 'pipelineStage', label: filters.pipelineStage });
        return chips;
    },
};
